<template>
    <div>
        <div style="font-size: 12px;color: #0E193B;">{{ title }}</div>
        <div style="font-size: 14px;color: #0E193B;font-weight: bold;margin-top: 6px;">{{ value }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],

            default: ''
        }
    },
 

}
</script>